import { useAuth0 } from "@auth0/auth0-vue";

export function useAccessToken() {

  const auth0 = process.client ? useAuth0() : undefined;

  async function getAccessToken() {

    console.log('getting token!');

    if (auth0?.isAuthenticated.value) {
      const token = await auth0?.getAccessTokenSilently();
      return token;
    } else {
      return '';
    }
  }

  return {
    getAccessToken
  }
}
